// @Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

// Third party
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';

// Local modules
import { PublicationsRoutingModule } from './publications-page-routing.module';
import { SharedModule } from '../shared/shared.module';
import { PublicationsPageComponent } from './publications-page.component';
import { TreeviewModule } from 'ngx-treeview';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    BsDropdownModule,
    PublicationsRoutingModule,
    SharedModule,
    TreeviewModule.forRoot()
  ],
  declarations: [
    PublicationsPageComponent
  ]
})
export class PublicationsPageModule { }



// WEBPACK FOOTER //
// ./src/app/publications-page/publications-page.module.ts